import React from 'react';
const media = window.matchMedia('(prefers-color-scheme: dark)');
const detect = () => media.matches ? 'dark' : 'light';
export const useTheme = () => {
    const [stateMediaTheme, setMediaTheme] = React.useState(detect);
    const [stateTheme, setTheme] = React.useState(() => ((x) => x === 'light' || x === 'dark' || x === 'custom' ? x : null)(localStorage.getItem('theme')));
    React.useEffect(() => {
        const root = document.querySelector(':root');
        if (stateTheme === 'custom') {
            root.setAttribute('data-bs-theme', 'custom');
            return;
        }
        const resolved = stateTheme ?? stateMediaTheme;
        if (resolved === 'dark') {
            root.setAttribute('data-bs-theme', 'dark');
            return;
        }
        root.removeAttribute('data-bs-theme');
    }, [stateTheme, stateMediaTheme]);
    React.useEffect(() => {
        const listener = () => setMediaTheme(detect());
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, []);
    return [
        stateTheme || stateMediaTheme,
        (x) => {
            if (x === null) {
                localStorage.removeItem('theme');
            }
            else {
                localStorage.setItem('theme', x);
            }
            setTheme(x);
        },
        stateTheme !== null
    ];
};
